import { NumberFormatOptions, formatNumber } from "../../../../../tools/string/formatNumber";

export function applyFormat(value: string | number | Date, format?: NumberFormatOptions): string {
   if (typeof value === "number") {
      return formatNumber(value, format);
   } else {
      return String(value);
   }
}
